import { createApi } from '@reduxjs/toolkit/query/react';

import { IApplicationContext } from '../types/ICustomContextParams';
import {
  fetchGetLocationBySubdomain,
  IGetLocationBySubdomainRequest,
} from '../repositories/geo-temp-layer/v1/get-location-by-subdomain';
import { prepareLocation } from '../mappers/prepareLocations';
import { ILocation } from '../types/location';
import { createBaseQuery } from './utils/createBaseQuery';
import { IGetRegionCityResponse } from '../repositories/geo-temp-layer/entities/response/GetRegionCityResponse';

export type TLocationApiEndpoints = keyof typeof locationApi.endpoints;
export let locationApi: ReturnType<typeof createLocationApi>;

export const createLocationApi = (ctx: IApplicationContext) => {
  const newApi = createApi({
    reducerPath: 'locationApi',
    baseQuery: createBaseQuery(ctx),

    endpoints: builder => ({
      getLocationByDomain: builder.query<ILocation, IGetLocationBySubdomainRequest>({
        query: parameters => ({
          parameters,
          fetchFunction: fetchGetLocationBySubdomain,
          loggerInfo: {
            description: 'Получение местоположения пользователя по домену',
            degradation: 'Критическая ошибка',
          },
        }),
        transformResponse: (response: IGetRegionCityResponse): ILocation => {
          return prepareLocation(response.item);
        },
      }),
    }),
  });

  locationApi = newApi;

  return newApi;
};
